class HotspotButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.hotspot-btn');
    this.content = this.querySelector('.hotspot__content');
    if (!this.button || !this.content) return;

    const parent = this.closest('.hf-hotspot-image');

    const schemaEvent = parent?.dataset.hotspotOpenEvent || 'click';
    const isTouch =
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(pointer: coarse)').matches ||
      window.matchMedia('(max-width: 749px)').matches;
    this.openEvent = isTouch ? 'click' : schemaEvent;
    this.header = document.querySelector('sticky-header');
    this._closeTimeout = null;

    const btnColor = parent?.dataset.hotspotsColor;
    const contentColor = parent?.dataset.contentColor;
    if (btnColor) this.button.classList.add('color-' + btnColor);
    if (contentColor) this.content.classList.add('color-' + contentColor);

    if (this._listenersBound) return;
    this._listenersBound = true;

    if (this.openEvent === 'click') {
      this.button.addEventListener('click', this.handleClick.bind(this));
    } else {
      this.button.addEventListener('mouseenter', this.openModal.bind(this));
      this.button.addEventListener('mouseleave', this.scheduleClose.bind(this));
      this.content.addEventListener('mouseenter', this.cancelClose.bind(this));
      this.content.addEventListener('mouseleave', this.scheduleClose.bind(this));
    }
  }

  static closeAllIn(container, except) {
    container.querySelectorAll('hotspot-button[data-open="true"]').forEach((el) => {
      if (el !== except) el.closeModal();
    });
  }

  openModal() {
    this.cancelClose();

    const parent = this.closest('.hf-hotspot-image');
    if (parent) HotspotButton.closeAllIn(parent, this);

    let headerBottom = this.header ? this.header.clientHeight : 0;
    if (
      this.header &&
      !this.header.classList.contains('shopify-section-header-hidden')
    ) {
      headerBottom = 0;
    }

    let limiteHaute = headerBottom;
    for (let n = this.parentElement; n && n !== document.body; n = n.parentElement) {
      if (getComputedStyle(n).overflow !== 'visible') {
        limiteHaute = Math.max(limiteHaute, n.getBoundingClientRect().top);
        break;
      }
    }

    if (this.content.getBoundingClientRect().top < limiteHaute) {
      this.dataset.direction = 'bottom';
    }

    this.dataset.open = 'true';

    this.querySelectorAll('video').forEach((v) => {
      try {
        v.currentTime = 0;
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
    });
    this.querySelectorAll('iframe[data-video-type]').forEach((iframe) => {
      try {
        const type = iframe.dataset.videoType;
        if (type === 'youtube') {
          iframe.contentWindow?.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            '*'
          );
        } else if (type === 'vimeo') {
          iframe.contentWindow?.postMessage('{"method":"play"}', '*');
        }
      } catch (_) {}
    });
  }

  scheduleClose() {
    this._closeTimeout = setTimeout(() => {
      this.closeModal();
    }, 200);
  }

  cancelClose() {
    clearTimeout(this._closeTimeout);
  }

  handleClick() {
    if (this.dataset.open === 'true') {
      this.closeModal();
    } else {
      this.openModal();
    }
  }

  closeModal() {
    this.cancelClose();
    this.dataset.open = 'false';
    setTimeout(() => {
      this.dataset.direction = '';
    }, 100);

    this.querySelectorAll('video').forEach((v) => {
      try { v.pause(); } catch (_) {}
    });
    this.querySelectorAll('iframe[data-video-type]').forEach((iframe) => {
      try {
        const type = iframe.dataset.videoType;
        if (type === 'youtube') {
          iframe.contentWindow?.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        } else if (type === 'vimeo') {
          iframe.contentWindow?.postMessage('{"method":"pause"}', '*');
        }
      } catch (_) {}
    });
  }
}

if (!customElements.get('hotspot-button')) {
  customElements.define('hotspot-button', HotspotButton);
}
